/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProfitAndLossGraphPlan$Params {
  id: string;

  /**
   * Номер страницы для пагинации данных.
   */
  page?: number;

  /**
   * Период агрегации данных. Возможные значения: 'month', 'year'.
   */
  period?: 'month' | 'year';
}

export function profitAndLossGraphPlan(
  http: HttpClient,
  rootUrl: string,
  params: ProfitAndLossGraphPlan$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    /**
     * Список дат, соответствующих периодам.
     */
    category: Array<string>;

    /**
     * Список серий данных, каждая из которых представляет метрику.
     */
    series: Array<{
      /**
       * Значения метрики для соответствующих дат.
       */
      data: Array<number>;

      /**
       * Название метрики (например, 'Выручка', 'Прибыль').
       */
      title: string;

      /**
       * Код метрики (например, 'revenue', 'profit').
       */
      code: string;
    }>;
  }>
> {
  const rb = new RequestBuilder(rootUrl, profitAndLossGraphPlan.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('period', params.period, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        /**
         * Список дат, соответствующих периодам.
         */
        category: Array<string>;

        /**
         * Список серий данных, каждая из которых представляет метрику.
         */
        series: Array<{
          /**
           * Значения метрики для соответствующих дат.
           */
          data: Array<number>;

          /**
           * Название метрики (например, 'Выручка', 'Прибыль').
           */
          title: string;

          /**
           * Код метрики (например, 'revenue', 'profit').
           */
          code: string;
        }>;
      }>;
    }),
  );
}

profitAndLossGraphPlan.PATH = '/api/project_calculations/profit_and_loss_plan_data/graph/{id}/';
